import api from './api';

export const dashboardAPI = {
    getRiepilogo: () => api.get('/dashboard/riepilogo'),
    getPromemoria: () => api.get('/dashboard/promemoria'),
    getConsensiMancanti: () => api.get('/dashboard/consensi-mancanti'),
};

export default dashboardAPI;
